export default "__VITE_ASSET__BzHNVYkn__"